import { CreateMessageBody, http } from '@Techedge/digitalportal-shared'
import { ActivitiesFiltersProps, ProjectStatus } from '../models/activities'
import { ReactionBody } from '../models/news'

export class r360Api {
    static BASE_URL: string = process.env.REACT_APP_BASE_URL_BE
    static HOME_URL: string = r360Api.BASE_URL + `/homeapi`
    static ACTIVITY_URL: string = r360Api.BASE_URL + `/projectsapi/activities`
    static SEARCH_API_URL: string = r360Api.BASE_URL + `/searchapi/activitylist`

    static headersObj = {
        headers: {
            'Accept-Language': '',
        },
        timeout: 180000,
    }

    static GetActions = () => {
        return http.get<any>(r360Api.BASE_URL, r360Api.headersObj)
    }

    static GetActivityDetail = (id: string) => {
        return http.get<any>(`${r360Api.ACTIVITY_URL}/${id}`, r360Api.headersObj)
    }

    static GetActivities = (filters: ActivitiesFiltersProps) => {
        let newParams: any = {}
        newParams.page = filters.page
        newParams.page_size = filters.page_size
        if (filters.tab) {
            newParams.tab = filters.tab
            delete filters.tab
        }
        if (filters.type) {
            newParams.type = JSON.stringify(filters.type)
            delete filters.type
        }
        if (filters.priority) {
            newParams.priority = JSON.stringify(filters.priority)
            delete filters.priority
        }
        newParams.start_date = JSON.stringify({ orderBy: 'DESC' })
        if (filters.start_date) {
            filters.start_date.value = new Date(filters.start_date.value as string).setHours(
                0,
                0,
                0
            )
            newParams.start_date = JSON.stringify(filters.start_date)
            delete filters.start_date
        }
        if (filters.end_date) {
            filters.end_date.value = new Date(filters.end_date.value as string).setHours(
                filters.end_date.hours || 0,
                filters.end_date.minutes || 0,
                filters.end_date.seconds || 0
            )
            delete filters.end_date.hours
            delete filters.end_date.minutes
            delete filters.end_date.seconds
            newParams.end_date = JSON.stringify(filters.end_date)
            delete filters.end_date
        }
        if (filters.more_information) {
            newParams.more_information = filters.more_information
            delete filters.more_information
        }
        if (filters.useIntervalDate) {
            newParams.useIntervalDate = filters.useIntervalDate
            delete filters.useIntervalDate
        }
        let queryString = new URLSearchParams(newParams).toString()

        return http.get<any>(
            `${r360Api.SEARCH_API_URL}?${queryString}&static=true&excludeStatus=${JSON.stringify({
                value: [ProjectStatus.CANCELLED, ProjectStatus.RECALLED, ProjectStatus.CLOSED],
            })}`,
            {
                ...r360Api.headersObj,
            }
        )
    }

    static ReactionToNews = (body: ReactionBody, id: string) => {
        return http.put<any>(
            `${r360Api.ACTIVITY_URL}/reaction/${id}`,
            { ...body },
            r360Api.headersObj
        )
    }
}
